"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
require("./Chip.css");
var icons_1 = require("@tiendanube/icons");
var Text_1 = __importDefault(require("../Text"));
function Chip(_a) {
    var id = _a.id, label = _a.label, Icon = _a.icon, onDismiss = _a.onDismiss;
    var handleClick = function () {
        onDismiss(id);
    };
    return (React.createElement("button", { type: "button", id: id, className: "nimbus--chip", onClick: handleClick },
        Icon && (React.createElement("div", { className: "nimbus--chip__icon" },
            React.createElement(Icon, null))),
        React.createElement(Text_1.default, { size: "caption" }, label),
        React.createElement("div", { className: "nimbus--chip__close" },
            React.createElement(icons_1.CloseIcon, null))));
}
exports.default = Chip;
//# sourceMappingURL=index.js.map